import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';
import { useState } from 'react';
import { Dialog } from '@headlessui/react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

export default function CarModal({ car, isOpen, onClose }) {
  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [sliderRef, slider] = useKeenSlider({
    slides: { perView: 1 },
    mode: 'snap',
    drag: true,
    slideChanged(s) {
      setSelectedIndex(s.track.details.rel);
    },
  });

  const currentIndex = car.gallery.indexOf(car.gallery[selectedIndex]);
  const handlePrevImage = () => {
    const prev = (currentIndex - 1 + car.gallery.length) % car.gallery.length;
    setSelectedIndex(car.gallery[prev]);
  };
  const handleNextImage = () => {
    const next = (currentIndex + 1) % car.gallery.length;
    setSelectedIndex(car.gallery[next]);
  };

  return (
    <Dialog open={isOpen} onClose={onClose} className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay that closes modal on outside click */}
      <div className="fixed inset-0 bg-black bg-opacity-50" aria-hidden="true" onClick={onClose} />

      <div className="bg-white rounded-lg p-6 md:p-8 max-w-4xl mx-auto z-50 relative overflow-y-auto max-h-[90vh]">
        {/* Gallery with arrows */}
        <div className="relative mb-6">
          <div className="flex flex-col md:flex-row gap-6 mb-8">
            {/* Thumbnails */}
            <div className="flex md:flex-col gap-3 md:w-1/4 overflow-x-auto md:overflow-y-auto scrollbar-hide">
              {car.gallery?.map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt={`Thumbnail ${i}`}
                  onClick={() => {
                    setSelectedIndex(i);
                    slider.current?.moveToIdx(i);
                  }}
                  className={`cursor-pointer rounded-md border ${selectedIndex === i ? 'border-brandBlue' : 'border-gray-200'
                    } w-20 h-20 object-cover hover:scale-105 transition-transform`}
                />
              ))}
            </div>

            {/* Main Image */}
            <div className="relative w-full overflow-hidden rounded-md">
              <div ref={sliderRef} className="keen-slider w-full">
                {car.gallery?.map((img, i) => (
                  <div key={i} className="keen-slider__slide flex justify-center items-center">
                    <img
                      src={img}
                      alt={`Slide ${i}`}
                      className="max-w-full max-h-[400px] object-contain"
                    />
                  </div>
                ))}
              </div>

              {/* Arrows */}
              <button
                onClick={() => slider.current?.prev()}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 p-2 rounded-full shadow hover:bg-opacity-100"
              >
                ◀
              </button>
              <button
                onClick={() => slider.current?.next()}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 p-2 rounded-full shadow hover:bg-opacity-100"
              >
                ▶
              </button>
            </div>
          </div>
        </div>

        {/* Car Name */}
        <h2 className="text-2xl font-bold mb-4">{car.name}</h2>

        {/* Specs */}
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4 text-gray-700 mb-6">
          <li><strong>Drivetrain:</strong> {car.specs?.drivetrain}</li>
          <li><strong>Range:</strong> {car.specs?.range}</li>
          <li><strong>Horsepower:</strong> {car.specs?.horsepower}</li>
          <li><strong>Battery:</strong> {car.specs?.battery}</li>
          <li><strong>Charging:</strong> {car.specs?.charging}</li>
        </ul>

        {/* Trim Comparison */}
        {car.specs?.trimDiff && (
          <div className="bg-gray-100 p-4 rounded-lg border-l-4 border-brandBlue mb-6">
            <h4 className="font-semibold text-gray-800 mb-2">Compared to Base Trim:</h4>
            <p className="text-gray-700 text-sm leading-relaxed">{car.specs.trimDiff}</p>
          </div>
        )}

        {/* Price + Button */}
        <div className="flex justify-between items-center mt-6">
          <span className="text-brandBlue font-bold text-lg">{car.price ? `$${car.price}/day` : ""}</span>
          <a
            href={car.turoUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-brandBlue text-white px-4 py-2 rounded-md hover:bg-blue-800 text-sm font-medium"
          >
            View Listing
          </a>
          {/* <Link to={`/fleet/${car.id}`}>
            <button className="bg-brandBlue text-white px-4 py-2 rounded-md hover:bg-blue-800 text-sm font-medium">
              View More
            </button>
          </Link> */}
        </div>

        {/* Close Button */}
        <button onClick={onClose} className="absolute top-2 right-2 text-gray-500 hover:text-gray-800">✕</button>
      </div>
    </Dialog>
  );
}